import { useContext } from 'react';

import { Button } from '@chakra-ui/react';

import { DealStateEnum } from '../../../../gql/dealGql';

import { isCanada } from '../../../../constants/countries';
import useGenerateBookSheets from '../../../../hooks/useGenerateBookSheets';
import { DealContext } from '../../../../libs/DealContext';

const CreateBookSheetButton = () => {
  const { deal, isRecalculatingPayoff } = useContext(DealContext);

  const { generateBookSheets, isLoading } = useGenerateBookSheets();

  const BOOK_SHEET_STATES = [
    DealStateEnum.Structuring,
    DealStateEnum.Closing,
    DealStateEnum.Closed,
    DealStateEnum.SentForSignatures,
    DealStateEnum.Signed,
  ];

  return BOOK_SHEET_STATES.includes(deal.state) && !isCanada(deal.country) ? (
    <Button
      variant="secondary"
      isLoading={isLoading}
      isDisabled={isRecalculatingPayoff}
      loadingText="CREATE BOOK SHEETS"
      onClick={() =>
        generateBookSheets({
          dealId: deal.id,
          customerState: deal.customer.address.state,
          country: deal.country,
        })
      }
    >
      CREATE BOOK SHEETS
    </Button>
  ) : null;
};

export default CreateBookSheetButton;
